import {connect} from 'react-redux';
import {State} from '../../../types/mx/reducers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';
import {AssemblyCountryInfoModalDispatchProps} from '../types/containers';
import AssemblyCountryInfoModalView from '../components/views/AssemblyCountryInfoModalView';

const mapStateToProps = (state: State) => {
    return {
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): AssemblyCountryInfoModalDispatchProps => {
    return {
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
    };
};

const AssemblyCountryInfoModalContainer = connect(
    mapStateToProps, mapDispatchToProps, mergeProps
)(AssemblyCountryInfoModalView);

export default AssemblyCountryInfoModalContainer;
